module.exports = __webpack_public_path__ + "static/img/company-component-coveEn-10-3.f36e4286.jpg";